<template>
  <div class="head">
    <ul class="nav-l">
    </ul>
    <div class="title-center"><span>生产预警预报</span></div>
    <ul class="nav-r">
      <li v-for="item in nav" :key="item.index" @click="hanle(item.url)" :class="routepath==item.url?'on':''">{{item.name}}</li>
    </ul>
    <AccountInfo></AccountInfo>
  </div>
</template>

<script>
import AccountInfo from '../layout/account-info';
export default {
  name: 'LayoutHeader',
  components:{
    AccountInfo
  },
  data () {
    return {
      nav: [
        {
          name: '工艺平稳率',
          url: '/productionalarm'
        }, {
          name: '报警率',
          url: '/productionalarm2'
        }, {
          name: '自控投运率',
          url: '/productionalarm3'
        }, {
          name: '联锁投运率',
          url: '/productionalarm4'
        }
      ],
      routepath:'',
      name:'生产预警预报'
    }
  },
  mounted () {
    let navl=this.nav;
    this.routepath=this.$route.path
    let getdata=navl[navl.findIndex((item) => item.url === this.routepath)]||{}
    if(Object.keys(getdata).length){
      this.name=getdata.name;
    }else if(this.routepath=='/malldetail'){
      this.routepath='/palletmall'
      this.name='托盘商城'
    }
  },
  methods: {
    hanle(url) {
      this.$router.push(url)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-l,.nav-r{min-width: 30%}
.title-center{
  font-size: 46px;
  font-family:"fzskjt";
  color: #D2DFFF;
  font-style: italic;
  text-shadow: 3px 2px 7px rgba(0,0,0,0.65);
  line-height: 180%;
  text-align: center;
}
.nav-r li{
  padding-right: 30px;
}
.head li{
  width: 156px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/production-alarm-header.vue